import React from 'react';

interface GetIconProps {
  fill: string;
  height: string;
  width: string;
}

export function GedIcon({ fill, height, width }: GetIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.08329 3.74992H3.33329V8.49992H0.166626V0.583252H8.08329V3.74992ZM31.8333 8.49992V0.583252H23.9166V3.74992H28.6666V8.49992H31.8333ZM8.08329 32.2499H3.33329V27.4999H0.166626V35.4166H8.08329V32.2499ZM28.6666 27.4999V32.2499H23.9166V35.4166H31.8333V27.4999H28.6666ZM27.0833 27.4999C27.0833 29.2416 25.6583 30.6666 23.9166 30.6666H8.08329C6.34163 30.6666 4.91663 29.2416 4.91663 27.4999V8.49992C4.91663 6.75825 6.34163 5.33325 8.08329 5.33325H23.9166C25.6583 5.33325 27.0833 6.75825 27.0833 8.49992V27.4999ZM20.75 11.6666H11.25V14.8333H20.75V11.6666ZM20.75 16.4166H11.25V19.5833H20.75V16.4166ZM20.75 21.1666H11.25V24.3333H20.75V21.1666Z"
        fill={fill}
      />
    </svg>
  );
}
